import React from "react"
import ThemeContext from "./src/Components/context/themeContext"


// export const wrapRootElement = ({ element }) => (
//   <ThemeContext>
//       {element}
//   </ThemeContext>
// )